// @core/api/endpoints/team/cancel_team_ownership_transfer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CancelTeamOwnershipTransferRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Cancel ownership transfer
 * Cancels a pending ownership transfer request. Only the initiator can cancel the transfer.
 */
export async function CancelTeamOwnershipTransfer(
  transfer_id: string,
  data: CancelTeamOwnershipTransferRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/ownership-transfers/:transfer_id/cancel`;
  requestPath = requestPath.replace(':transfer_id', encodeURIComponent(transfer_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
